export default __webpack_public_path__ + "static/media/comfort4.4772a0bf.jpg";